import { jsx as _jsx } from "react/jsx-runtime";
import { Trash as TrashIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useAirModal } from "@air/provider-modal";
import { hasSelectedItemsSelector } from "@air/redux-selected-items";
import { memo } from "react";
import { useSelector } from "react-redux";
import { BoardCollectionDeleteClipsModal } from "~/components/BoardCollection/BoardCollectionDeleteClipsModal";
import { ACTION_BAR_DELETE } from "~/constants/testIDs";
import { selectedClipsSelector } from "~/store/selectedItems/selectors";
export const BoardCollectionDeleteButton = /*#__PURE__*/ memo(()=>{
    const hasSelectedItems = useSelector(hasSelectedItemsSelector);
    const selectedClipItems = useSelector(selectedClipsSelector);
    const { isAboveMediumScreen } = useBreakpointsContext();
    const [showDeleteClipsModal] = useAirModal(BoardCollectionDeleteClipsModal);
    if (isAboveMediumScreen) {
        return /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            color: "grey",
            prefix: /*#__PURE__*/ _jsx(TrashIcon, {
                className: "size-4"
            }),
            onClick: ()=>showDeleteClipsModal({
                    clips: selectedClipItems
                }),
            disabled: !hasSelectedItems,
            "data-testid": ACTION_BAR_DELETE,
            size: "large",
            children: "Delete"
        });
    }
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        className: "mr-2",
        color: "grey",
        disabled: !hasSelectedItems,
        icon: TrashIcon,
        label: "Delete",
        onClick: ()=>showDeleteClipsModal({
                clips: selectedClipItems
            }),
        size: "large",
        "data-testid": ACTION_BAR_DELETE
    });
});
BoardCollectionDeleteButton.displayName = "BoardCollectionDeleteButton";
